import React, { memo, useContext } from 'react';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import './css/TicketsComponent1.css';
import CounterComponent from '../../storeComponents/counterComponent/CounterComponent';
import { getHTMLTextFromNormalText, getOptimXBackgroundStyle } from '../../../../catalog/Website';
import { showPriceFromCents } from '../../../../catalog/Price';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { TicketEventType } from '../../../../catalog/enums/TicketEventType';
import { getLocalTimeFromDatabaseTime, getDateTimeStringFromDate } from '../../../../catalog/DateTime';
import ImageWithTitleComponent2 from '../../imageWithTitleComponents/imageWithTitleComponent2/ImageWithTitleComponent2';
import InfoComponent from '../../storeComponents/infoComponent/InfoComponent';
import { context } from '../../../../globalState/GlobalState';

const TicketsTicketComponent1 = (props) => {
    const { ticket, quantity, setState } = props;
    const { globalState } = useContext(context);

    const getImage = () => {
        if (isValidString(ticket.featureImage)) {
            return ticket.featureImage;
        }
        return '';
    };

    // Published is commented out because this is how private tickets are supported
    const showTicket = () => {
        if (ticket.deleted) {
            return false;
        }
        //  if (!ticket.published) {
        //     return false;
        // }
        if (!isValidString(ticket.stripeProductId)) {
            return false;
        } if (!ticket.inStock) {
            return false;
        } if (ticket.prices.length <= 0) {
            return false;
        }
        return true;
    };

    const getTotalPricePerTicket = (price) => {
        if (isValidObject(quantity[price.id])) {
            return price.price * quantity[price.id];
        }
        return 0;
    };

    const totalQuantity = () => {
        let total = 0;
        const priceIds = ticket.prices.map((price) => {
            return price.id;
        });
        Object.keys(quantity).forEach((priceId) => {
            if (priceIds.includes(priceId)) {
                total += quantity[priceId];
            }
        });

        return total;
    };

    const ticketsAvailable = () => {
        return ticket.ticketsTotal - ticket.ticketsSold - ticket.ticketsHold;
    };

    const getTicketsAvailableText = () => {
        const ticketsAvailableLocal = ticketsAvailable();

        if (ticketsAvailableLocal < 10 && ticketsAvailableLocal > 1) {
            return <InfoComponent info={`${ticketsAvailableLocal} Tickets Available`} />;
        }
        if (ticketsAvailableLocal === 1) {
            return <InfoComponent info="1 Ticket Available" />;
        }
        if (ticketsAvailableLocal < 1) {
            return <InfoComponent info="Tickets Unavailable" />;
        }
        return null;
    };

    // const getFutureTicketsAvailableText = () => {
    //     const ticketsAvailable = ticket.ticketsTotal - ticket.ticketsSold - ticket.ticketsHold;
    //     const futureTicketsAvailable = ticket.ticketsTotal - ticket.ticketsSold;

    //     if (ticketsAvailable < 10) {
    //         if (ticketsAvailable !== futureTicketsAvailable) {
    //             return <p className="alegreya-font-family font-spacing-wider line-height-wider text-left-align m-t-0 m-l-20px m-r-20px">{`${futureTicketsAvailable - ticketsAvailable} tickets are reserved but not booked yet. These tickets might be available in an hour if they are not booked.`}</p>
    //         }

    //     }

    //     return null
    // }

    return (
        <React.Fragment key={ticket.id}>
            {showTicket() ? (
                <>
                    {ticket.eventType !== TicketEventType.TICKET_EVENT ? <h2 className="tickets-component1-subtitle alegreya-font-family font-size-3xl font-weight-800 text-left-align text-uppercase m-t-50px m-b-20px m-l-20px m-r-20px">{ticket.title}</h2> : null}
                    {ticket.eventType === TicketEventType.TICKET_EVENT ? <p className="alegreya-font-family font-spacing-wider line-height-wider text-left-align m-t-0 m-l-20px m-r-20px">{`Venue: ${ticket.eventVenue}`}</p> : null}
                    {ticket.eventType === TicketEventType.TICKET_EVENT ? <p className="alegreya-font-family font-spacing-wider line-height-wider text-left-align m-t-0 m-l-20px m-r-20px">{`Time: ${getDateTimeStringFromDate(getLocalTimeFromDatabaseTime(ticket.timeOfEvent))} - ${getDateTimeStringFromDate(getLocalTimeFromDatabaseTime(ticket.endTimeOfEvent))}`}</p> : null}
                    {getTicketsAvailableText()}
                    {/* {ticketsAvailable() < 0 && ticketsAvailableFuture() > 0 ? <p className="alegreya-font-family font-spacing-wider line-height-wider text-left-align m-t-0 m-l-50px m-r-50px">{`Not available at the moment but ${ticketsAvailableFuture()} might get available in the next hour`}</p> : null} */}
                    {isValidString(getImage()) ? (
                        <div className="tickets-component1-image m-l-20px m-r-20px">
                            <ImageWithTitleComponent2 title={ticket.title} image={getImage()} alt="Ticket Feature Image" />
                            <div className="m-t-50px" />
                        </div>
                    ) : null}
                    {isValidString(ticket.shortDescription)
                        ? (
                            <div className="tickets-component1-text alegreya-font-family font-spacing-wider line-height-wider text-left-align m-t-10px m-l-20px m-r-20px">
                                {parse(getHTMLTextFromNormalText(ticket.shortDescription))}
                            </div>
                        )
                        : null}
                    <div className="tickets-component1-table box-shadow-black m-t-20px m-l-20px m-r-20px">
                        <div className="tickets-component1-price-header-container" style={getOptimXBackgroundStyle(globalState)}>
                            <p className="tickets-component1-price-header-description text-left-align m-t-0 m-b-0">Tickets</p>
                            <p className="tickets-component1-price-header-price text-center-align m-t-0 m-b-0">Price</p>
                            <p className="tickets-component1-price-header-quantity text-center-align m-t-0 m-b-0">Quantity</p>
                            <p className="tickets-component1-price-header-total text-right-align m-t-0 m-b-0">Subtotal</p>
                        </div>
                        {ticket.prices.map((price) => {
                            return (
                                <React.Fragment key={price.id}>
                                    {price.published && isValidString(price.stripePriceId) ? (
                                        <div className="tickets-component1-price-container">
                                            <div className="tickets-component1-price-description text-left-align">
                                                <p className="alegreya-font-family text-uppercase m-t-0 m-b-0">{price.title}</p>
                                                <p className="alegreya-font-family font-weight-300 font-size-s m-t-0 m-b-0">{parse(getHTMLTextFromNormalText(price.description))}</p>
                                            </div>
                                            <p className="tickets-component1-price-price normal-font-family font-weight-400 text-center-align m-t-0 m-b-0">{showPriceFromCents(price.price)}</p>
                                            <div className="tickets-component1-price-quantity text-center-align">
                                                <CounterComponent
                                                    count={isValidObject(quantity[price.id]) ? quantity[price.id] : 0}
                                                    increment={() => { setState({ type: 'incrementQuantity', id: price.id }); }}
                                                    decrement={() => { setState({ type: 'decrementQuantity', id: price.id }); }}
                                                    disableIncrement={totalQuantity() >= ticketsAvailable()}
                                                />
                                            </div>
                                            <p className="tickets-component1-price-total normal-font-family font-weight-400 text-right-align m-t-0 m-b-0">{showPriceFromCents(getTotalPricePerTicket(price))}</p>
                                        </div>
                                    ) : null}
                                </React.Fragment>
                            );
                        })}
                    </div>
                </>
            ) : null}
        </React.Fragment>
    );
};

TicketsTicketComponent1.propTypes = {
    ticket: PropTypes.object.isRequired,
    quantity: PropTypes.object.isRequired,
    setState: PropTypes.func.isRequired,
};

export default memo(TicketsTicketComponent1);
